import { SelectedSetsData } from '@/components/SetsSelectedData';
import { useTextsetContext } from '@/contexts/TextSetContext/useTextsetContext';
import { Filter } from './Filter';
import { Header } from './Header';
import {
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  StyleSheet,
} from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { StackScreenProps } from '@react-navigation/stack';
import { TherapistStackParamList } from '@/navigations/TherapistStack';

type SetsSelectedWrapperProps = {
  props: StackScreenProps<TherapistStackParamList, 'TextSet'>;
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  scrollStyle: {
    margin: 28,
    flex: 1,
  },
});

export function SetsSelectedWrapper({ props }: SetsSelectedWrapperProps) {
  const {
    data,
    selectedData,
    changeSelectedData,
    patientId,
    page,
    changePage,
    limitModal,
    changeLimitModal,
    setId,
    editData,
    dataKeyName,
    apiKeyName,
    dynamicName,
    textLength,
    scrollViewRef,
  } = useTextsetContext();

  const propz = {
    data,
    selectedData,
    changeSelectedData,
    patientId,
    page,
    changePage,
    limitModal,
    changeLimitModal,
    setId,
    editData,
    dataKeyName,
    apiKeyName,
    dynamicName,
    textLength,
  };

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : undefined}
      style={{ flex: 1 }}
      keyboardVerticalOffset={Platform.OS === 'ios' ? 80 : 0}
    >
      <SafeAreaView style={styles.container}>
        <Header props={props} />
        <ScrollView ref={scrollViewRef} style={styles.scrollStyle}>
          <Filter />
          <SelectedSetsData isTextSet {...propz} />
        </ScrollView>
      </SafeAreaView>
    </KeyboardAvoidingView>
  );
}
